import { tokens, FontIcon } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

import { CommandButton } from '../PlayerBar.styles'

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  @media (max-width: ${tokens.sizes.mdScreen}px) {
    display: none;
  }
`

export const Volume = styled.div`
  display: flex;
  align-items: center;
  max-width: 200px;
`

export const VolumeIcon = styled(FontIcon).attrs(() => ({
  iconName: 'volume',
  size: 20,
  color: tokens.colors.black5
}))`
  margin: 15px;
`

export const CloseButton = styled(CommandButton).attrs(props => ({
  iconName: 'cancel',
  iconColor: tokens.colors.black4,
  iconSize: 12,
  disabled: props.disabled
}))`
  align-self: flex-end;
  visibility: ${({ disabled }) => (disabled ? 'hidden' : 'visible')};
`
